export default function () {
    return {
        products: []
    }
}